import * as React from 'react';
import './PlaceTag.css';

interface IPlaceTagProps
  extends React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  selected?: boolean;
  onClick?: () => void;
  onDeleteClick?: () => void;
}

function getContainerClassName(selected: boolean | undefined): string {
  if (selected) {
    return 'PlaceTag PlaceTag-selected';
  }
  return 'PlaceTag';
}

/**
 * タグを1つ表示する。
 * onClickを渡したときはタグの名前をボタンにし、onDeleteClickを渡したときは名前の右に削除ボタンを並べる。
 * 2つのボタンは入れ子にせず、外側のspanの中に横並びに置く。
 * ボタンのHTML属性（titleなど）は、名前のボタンがあるときにそのボタンへ渡す。
 */
export const PlaceTag: React.FC<IPlaceTagProps> = function ({
  selected,
  onClick,
  onDeleteClick,
  children,
  ...buttonHTMLProps
}) {
  return (
    <span className={getContainerClassName(selected)}>
      {(function () {
        if (!onClick) {
          return <span className="PlaceTag-label">{children}</span>;
        }
        return (
          <button
            type="button"
            {...buttonHTMLProps}
            className="PlaceTag-label PlaceTag-label_button"
            aria-pressed={selected}
            onClick={() => onClick()}
          >
            {children}
          </button>
        );
      })()}
      {(function () {
        if (!onDeleteClick) {
          return null;
        }
        return (
          <button
            type="button"
            className="PlaceTag-delete_button"
            title="タグを削除"
            aria-label="タグを削除"
            onClick={(e) => {
              e.stopPropagation();
              onDeleteClick();
            }}
          >
            ×
          </button>
        );
      })()}
    </span>
  );
};
